import React from "react";

import Paragraph from '../../Paragraph/Paragraph';
import PromoSection from "../PromoSection/PromoSection";
import styles from "./Support.module.scss";

export default function Support() {
  return (
    <div>
      <div className={styles.container}>
        <Paragraph
          title="Chúng tôi biết rằng PipFarm hiện đang cung cấp nhiều chương trình khuyến mãi. Bạn có thể cho chúng tôi biết thêm về các chương trình này không?"
          content={[
            'Mỗi tháng, chúng tôi đều có một chương trình khuyến mãi đặc biệt để gắn kết cộng đồng giao dịch của mình. Đôi khi, chúng tôi cung cấp giảm giá đơn giản cho chi phí thử thách; đôi khi, chúng tôi cho phép thử lại miễn phí nếu họ không hoàn thành thử thách, cấp thêm số dư trong các tài khoản giao dịch mô phỏng, và tăng điểm kinh nghiệm để giúp tăng hạng và mở khóa các phần thưởng mới.',
            'Chúng tôi cũng có những ưu đãi đặc biệt cho các sự kiện quan trọng như Năm Mới hoặc Black Friday. Cách tốt nhất để biết về các chương trình khuyến mãi đang diễn ra là tham gia cộng đồng Discord hoặc danh sách gửi thư của chúng tôi.',
          ]}
        />
        <Paragraph
          title="Có ưu đãi nào đặc biệt cho các nhà giao dịch tại Việt Nam nói chung và khách hàng của VnRebates nói riêng không?"
          content={[
            'Có chứ. Chúng tôi rất vui mừng được cung cấp giảm giá độc quyền 30% cho cộng đồng VnRebates khi tham gia thử thách giao dịch PipFarm lần đầu tiên. Hy vọng bạn sẽ cải thiện khả năng giao dịch và được thưởng vì hiệu suất giao dịch của mình.',
          ]}
        />
      </div>
      <PromoSection />
    </div>
  );
}
